module.exports = __webpack_public_path__ + "fonts/Mukta-200-devanagari1.f681524.woff2";